export default __webpack_public_path__ + "images/assets/8ff5fedffadc450f45e68a342c44c774.svg";